import(/* webpackMode: "eager" */ "/Users/ataturkoglu/Documents/Pomza Export/pomzaexport_next/src/app/[locale]/product/[slug]/page.jsx");
